<script>
    import { createEventDispatcher } from "svelte";
    import evidenceService from "../../../services/evidence.js";
    import { format } from "svelte-i18n";

    let { finding_id } = $props();

    let showUploadButton = false;
    let files = $state([]);
    let isDragging = $state(false);
    let fileInput;

    let errors = $state([]);
    let files_uploaded = $state([]);
    let files_uploading = $state(false);
    let show_finish_btn = $state(false);

    const dispatch = createEventDispatcher();
    const loadFile = (e) => {
        files = e.target.files;
        showUploadButton = true;
    };

    const cancelFileUpload = () => {
        files = [];
        errors = [];
        files_uploaded = [];
        showUploadButton = false;
        show_finish_btn = false;
    };

    const finishFileUpload = () => {
        files = [];
        errors = [];
        files_uploaded = [];
        showUploadButton = false;
        show_finish_btn = false;
        dispatch("files_uploaded");
    };

    const uploadFile = async () => {
        show_finish_btn = false;
        files_uploading = true;

        let filesArray = Array.from(files);
        for (let file of filesArray) {
            try {
                let response = await evidenceService.save(
                    { finding_id: finding_id, description: file.description },
                    file,
                );
                files_uploaded.push(file.name);
                files_uploaded = files_uploaded;
            } catch (e) {
                errors.push({
                    //msg: translateErrorMessages(e),
                    fileName: file.name,
                });
                errors = errors;
                //return false;
            }
        }

        showUploadButton = false;
        files_uploading = false;
        show_finish_btn = true;
    };

    // Prevent browser from opening the file when dropped
    function handleDragOver(event) {
        event.preventDefault();
        isDragging = true;
    }

    function handleDragLeave() {
        isDragging = false;
    }

    function handleDrop(event) {
        event.preventDefault();
        isDragging = false;

        if (event.dataTransfer?.files) {
            processFiles(event.dataTransfer.files);
        }
    }

    // Fallback for regular file selection on click
    function handleFileSelect(event) {
        const target = event.target;
        if (target.files) {
            processFiles(target.files);
        }
    }

    function processFiles(fileList) {
        files = [...files, ...Array.from(fileList)];
    }
</script>

<div class="mb-3">
    <!-- {#if files.length}
        {#each Array.from(files) as file}
            <div class="mb-3">
                <span>{file.name}</span>
            </div>
        {/each}

    {:else}
        <label for="evidencesFileInput" style="display: block; float: left; clear:both;">
            <i class="fas fa-file-upload"  style="cursor: pointer; font-size: 20px;" title="Seleccionar archivo">
                <input id="evidencesFileInput" style="opacity: 0; width: 0px;" oninput="{(e)=> loadFile(e)}" class="" type="file" accept="image/png" multiple="multiple" bind:this={fileInput} />
            </i>
            <span style="font-weight: 400;">Seleccionar o arrastrar archivo</span><small>&nbsp;(imágenes sólo en formato .png)</small>
        </label>
    {/if} -->
    <div
        class="dropzone {isDragging ? 'active' : ''}"
        ondragover={handleDragOver}
        ondragleave={handleDragLeave}
        ondrop={handleDrop}
        onclick={() => fileInput.click()}
    >
        <!-- Hidden native file input for click-to-upload accessibility -->
        <input
            type="file"
            bind:this={fileInput}
            onchange={handleFileSelect}
            multiple
            hidden
        />

        {#if isDragging}
            <p>Drop your files here</p>
        {:else}
            <p>Drag & drop files here, or <strong>click to browse</strong></p>
        {/if}
    </div>
    {#if files.length > 0}
        <ul class="file-list">
            {#each files as file}
                <li>{file.name} ({(file.size / 1024).toFixed(1)} KB)</li>
            {/each}
        </ul>
    {/if}
    <div class="mt-3">
        {#if show_finish_btn}
            <button class="btn btn-primary" onclick={() => finishFileUpload()}
                >Finalizar</button
            >
        {:else if !files_uploading}
            {#if files && files[0] && !errors.length && !files_uploaded.length}
                <button
                    class="btn btn-xs btn-primary mt-1"
                    title="Enviar archivo"
                    onclick={() => uploadFile()}
                >
                    <span>{$format("buttons.save")}</span>
                </button>
                <button
                    class="btn btn-xs btn-default mt-1 ms-1"
                    title="Cancelar"
                    onclick={() => cancelFileUpload()}
                >
                    <span>{$format("buttons.cancel")}</span>
                </button>
            {/if}
        {:else}
            <i class="fas fa-sync-alt fa-spin"></i>
        {/if}
    </div>
    {#if errors.length}
        {#key errors}
            {#each errors as error}
                <div
                    class="mt-3"
                    style="color: white; padding: 7px; border-radius: 4px; background: #dc3545e0; width: fit-content;"
                >
                    <div>
                        No pudo cargarse el archivo <strong
                            >{error.fileName}</strong
                        >
                    </div>
                    {#if error.msg}<div class="mt-1">
                            <strong>Error</strong>: {error.msg}
                        </div>{/if}
                </div>
            {/each}
        {/key}
    {/if}
    {#if files_uploaded.length}
        <div class="mt-3"><strong>Archivos cargados con éxito</strong>:</div>
        {#key files_uploaded}
            {#each files_uploaded as fileName}
                <div class="" style="color: rgb(40, 167, 69);">
                    <div><strong>{fileName}</strong></div>
                </div>
            {/each}
        {/key}
    {/if}
</div>

<style>
    .dropzone {
        border: 2px dashed #ccc;
        border-radius: 8px;
        padding: 40px;
        text-align: center;
        background: #fdfdfd;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
    }

    .dropzone.active {
        border-color: #0c67dd;
        background: #f2f5ffe5;
    }

    .file-list {
        margin-top: 15px;
        list-style: none;
        padding: 0;
    }

    .file-list li {
        padding: 8px;
        background: #eee;
        margin-bottom: 5px;
        border-radius: 4px;
    }
</style>
